/** @jsx jsx */
import { jsx } from '@emotion/core';
import { withNamespaces } from 'react-i18next';
import defaultsDeep from 'lodash/defaultsDeep';
import { keyColors } from '../../../styles/colors/index';
import Spacer from '../../ui/Spacer';
import Cookies from 'universal-cookie';
import createButtonCss from '../../ui/Button/Button';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  agreeButtonCss,
  cookieBannerWrapperCss,
  linkCss,
  mainTextCss,
  spacerCss,
} from './index.styles';

const defaultData = {
  MainText: {
    value: '',
  },
  Link: {
    value: '',
  },
  UrlText: {
    value: '',
  },
};

const cookieState = {
  REJECTED: 'rejected',
  ACCEPTED: 'accepted',
};

const COOKIE_KEY_NAME = 'cpa';

class CookiePolicyBanner extends SafePureComponent {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.state = {
      showCookie: null,
    };
  }

  onClickCookieButton = () => {
    const currentDate = new Date();
    const nextYear = new Date();
    nextYear.setFullYear(currentDate.getFullYear() + 1);

    this.cookies.set(COOKIE_KEY_NAME, cookieState.ACCEPTED, {
      expires: nextYear,
      path: '/',
    });

    this.setState({ showCookie: cookieState.ACCEPTED });
  };

  componentDidMount() {
    const policyState =
      this.cookies.get(COOKIE_KEY_NAME) || cookieState.REJECTED;
    this.setState({ showCookie: policyState });
  }

  safeRender() {
    const { t } = this.props;
    const fields = defaultsDeep(this.props.fields, defaultData);
    const { MainText, UrlText, Link } = fields;
    const { showCookie } = this.state;
    return (
      showCookie === cookieState.REJECTED && (
        <Spacer backgroundColor={keyColors.black} customCss={spacerCss}>
          <div css={cookieBannerWrapperCss}>
            <p css={mainTextCss}>
              {`${MainText.value} `}
              <a css={linkCss} href={Link.value}>
                {UrlText.value}
              </a>
            </p>
            <button
              onClick={this.onClickCookieButton}
              css={[
                createButtonCss('secondary', {
                  theme: 'dark',
                }),
                agreeButtonCss,
              ]}
            >
              {t('CookiePolicyBannerCTA')}
            </button>
          </div>
        </Spacer>
      )
    );
  }
}

CookiePolicyBanner.displayName = 'CookiePolicyBanner';

export default withNamespaces()(CookiePolicyBanner);
